import { styled, TableCell, TableRow } from '@mui/material';
import { withPropsExclusion } from 'utils/functions';

export const RoundedHeaderTableRow = styled(TableRow)(({ theme }) => ({
  '& > th:first-child': {
    borderTopLeftRadius: theme.spacing(1),
    borderBottomLeftRadius: theme.spacing(1)
  },
  '& > th:last-child': {
    borderTopRightRadius: theme.spacing(1),
    borderBottomRightRadius: theme.spacing(1)
  }
}));

export const ThemedHeaderTableCell = styled(TableCell)(({ theme }) => ({
  color: theme.palette.common.white,
  backgroundColor: theme.palette.primary.main,
  fontWeight: 'bold',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  border: 'none'
}));

export const SizedTableRow = styled(
  TableRow,
  withPropsExclusion('height')
)(({ theme, height }) => ({
  '& td': {
    paddingBlock: theme.spacing(1),
    height: typeof height === 'number' ? `${height}px` : height
  }
}));
